import React from 'react'
import {
  StyledGroup1,
  StyledCheckbox2,
} from 'components/UIElements/FilterCheckBoxComp/style'
import Flex from 'components/Flex'
import  Checkbox  from 'components/Form/Checkbox'

const FilterCheckBoxComp = ({
  value,
  options,
  onChange,
  padding = '1rem 10px !important',
  valueParam = 'value',
  labelParam = 'label',
  onChangeCheck,
  gap,
  column = 'column',
  margin = 0,
  style,
  weight = 400,
}) => {
  return (
    <StyledGroup1
      value={value}
      onChange={onChange}
      gap={gap}
      margin={margin}
      column={column}
      style={style}
    >
      {options?.map((item, index) => (
        <Flex spaceBetween centerVertically key={item[valueParam]}>
          {item?.[labelParam]?.length > 0 && (
            <Checkbox
            color={'#303030'}
            weight={weight}
              value={item[valueParam]}
              label={item[labelParam]}
              onChange={onChangeCheck}
              padding={padding}
            />
          )}
        </Flex>
      ))}
    </StyledGroup1>
  )
}

export default FilterCheckBoxComp
